<template>
  <div>
    <CardedTable :items="items" :headers="headers" :show_description="true">
      <template v-slot:[`item.is_active`]="{ item }">
        {{ parseInt(item.is_active) == 1 ? "Active" : "Disabled" }}
      </template>
      <template v-slot:[`item.date_expired`]="{ item }">
        {{ item.date_expired == "1989-01-01" ? "" : item.date_expired }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
      <template v-slot:description>
        <p class="text-left ml-4 mr-4">
          There {{ active_subs == 1 ? "is" : "are"}}  {{ active_subs }} Active News Letter Subscriptions
        </p>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedTable from "../../../components/CardedTable";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminNewsLettersList",
  components: {
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: false,
    },
  },
  data: () => {
    return {
      items: [],
      headers: [
        {
          text: "Email Address",
          align: "start",
          sortable: true,
          value: "email_address",
          filterable: true,
        },
        { text: "Status", value: "is_active" },
        { text: "Expired Date", value: "date_expired", align: "center" },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    load_items() {
      this.$emit("on-show-loader");
      ServerClient.NewsLetterSubscriptions.get_news_letter_subscriptions(
        {
          is_admin: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.items = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading subscriptions on admin subscriptions list"
          );
        }
      );
    },
    on_view_item(item) {
      this.$router.push("/admin/new_letters/list/view/" + item.id);
    },
  },
  computed: {
    active_subs() {
      var num = 0;
      for (let index = 0; index < this.items.length; index++) {
        const item = this.items[index];
        if (parseInt(item.is_active) == 1) {
          num = num + 1;
        }
      }
      return num;
    },
  },
  mounted() {
    this.$emit("set-page-attributes", {
      title: "News Letters Subscriptions List",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "News Letters",
          disabled: false,
          href: "/admin/new_letters",
        },
        {
          text: "Subscriptions",
          disabled: true,
          href: "/admin/new_letters/list",
        },
      ],
    });
    this.load_items();
  },
};
</script>